export enum AddressOwnershipTypeEnum {
    Unknown = 0,
    /**
     * Property is Owned
     */
    Own = 1,
    /**
     * Property is Rented
     */
    Rent = 2,
}

const addressOwnershipTypeEnumDescription = {
    Unknown: 'Unknown',
    Own: 'Property is Owned',
    Rent: 'Property is Rented',
};

export const AddressOwnershipTypeEnumDescription = {
    ...addressOwnershipTypeEnumDescription,

    get: (value: AddressOwnershipTypeEnum | undefined | null): string | undefined => {
        if (typeof (value) === "string") {
            return addressOwnershipTypeEnumDescription[value];
        }
        if (value===null || value===undefined) {
            return undefined;
        }
        return addressOwnershipTypeEnumDescription[AddressOwnershipTypeEnum[value]  as keyof typeof addressOwnershipTypeEnumDescription];
    },
    all: [
        { value: 0, label: addressOwnershipTypeEnumDescription.Unknown },
        { value: 1, label: addressOwnershipTypeEnumDescription.Own },
        { value: 2, label: addressOwnershipTypeEnumDescription.Rent },
    ] as ReadonlyArray<{label: string, value: number}>
};
